import CryptoJS from 'crypto-js'
export function debounce(func, delay) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), delay);
    };
}


export const getSeatAmenityBgColor = (seat) => {
    const amenityId = Number(seat?.SeatAmenityID) || 0;
    if (amenityId === 1) return 'rgb(155, 242, 254)';
    if (amenityId === 2) return 'rgb(218, 180, 131)';
    if (amenityId === 3) return 'rgb(255, 147, 187)';
    return null;
};

export const isNonBookableAmenitySeat = (seat) =>
    [1, 2, 3].includes(Number(seat?.SeatAmenityID));

export const applySeatAmenity = (seat) => {
    const amenityId = Number(seat?.SeatAmenityID) || 0;
    if (amenityId === 0) return seat;

    const amenityBgColor = getSeatAmenityBgColor(seat);
    switch (amenityId) {
        case 1:
            return { ...seat, IsAisle: false, SeatLabel: 'Toilet', amenityBgColor };
        case 2:
            return { ...seat, SeatLabel: 'E Ex', amenityBgColor };
        case 3:
            return { ...seat, SeatLabel: 'R Ex', amenityBgColor };
        default:
            return seat;
    }
};

const isBookedSeat = (ell) =>
    ell?.IsAvailable === 0 && ell?.BookingID?.trim?.() !== '' && ell.BookingID != null;

const resolveSeatBackgroundColor = (ell, bkgColor, selectSeat, defaultColor) => {
    const selected = selectSeat?.filter((obj) => obj?.SeatLabel === ell?.SeatLabel);
    if (selected?.length !== 0) return '#fac736';
    const amenityBg = getSeatAmenityBgColor(ell);
    if (amenityBg && !isBookedSeat(ell)) return amenityBg;
    return defaultColor;
};

export const chartFormatData = (data, options = {}) => {
    if (!data?.ChartLayoutWithFare || !data?.BookingStatus) {
        return [];
    }

    const chartLayoutData = JSON.parse(data.ChartLayoutWithFare)?.Table || [];
    const bookingStatus = JSON.parse(data.BookingStatus);
    const Bkgdata = bookingStatus?.Table || [];
    const AppAgentID = bookingStatus?.Table1?.[0]?.AppAgentID?.split('|')?.map(Number) || [];
    const { companyListAll } = options;

    return chartLayoutData.map((item1) => {
        const match = Bkgdata.find((item2) => item2.SeatNo === item1.SeatLabel);
        let bkgType = '';

        if (match?.BookingType === 'AC' && companyListAll) {
            bkgType = 'AC';
            const CountAPI = AppAgentID?.includes(match?.ForAgentID) || false;

            if (companyListAll?.HasColorCodeForAgentOffline && match?.IsOnlineBooking === 0) {
                bkgType = 'ACO';
            } else if (
                companyListAll?.HasColorCodeForWalletAndCard &&
                (match?.paymentModeID == 2 || ['MO', 'RO', 'KO'].includes(match?.pgUsed))
            ) {
                bkgType = 'ACW';
            } else if (companyListAll?.HasColorCodeForApiAgentColor && CountAPI) {
                bkgType = 'API';
            }
        }

        const seat = {
            ...item1,
            ...match,
            SeatAmenityID: item1?.SeatAmenityID ?? match?.SeatAmenityID ?? 0,
            IsAvailable: match === undefined ? 1 : 0,
            ...(companyListAll !== undefined ? { newBkgType: bkgType || match?.BookingType } : {}),
        };

        return applySeatAmenity(seat);
    });
};

export const parseSeats1 = (stchrt, countLower = 0, countUpper = 0) => {
    const groupedData = {};
    let fares = [];
    let newCountLower = countLower;
    let newCountUpper = countUpper;

    stchrt.forEach((seat) => {
        const deck = seat.Deck === 1 ? 'lower' : 'upper';
        if (seat.BaseFare !== 0 && fares.indexOf(seat.BaseFare) === -1) {
            fares.push(seat.BaseFare)
        }

        const columnNo = seat.ColumnNo;
        if (!groupedData[deck]) {
            groupedData[deck] = {};
        }

        if (!groupedData[deck][columnNo]) {
            groupedData[deck][columnNo] = [];
        }
        if (['sleeper', 'seat', "semisleeper"]?.includes(seat.SeatType) && seat?.IsAvailable === 1) {
            if (seat.Deck === 1) {
                newCountLower++
            } else {
                newCountUpper++
            }
        }
        groupedData[deck][columnNo].push(seat);
    });
    let lower = parseSt(groupedData?.lower || {})
    let upper = parseSt(groupedData?.upper || {})
    let lowerWidth = Object.keys(lower).reduce((sum, key) => {
        let width = 54;
        if (Array.isArray(lower[key])) {
            lower[key].forEach((obj) => {
                if (obj.Width !== 1) {
                    width = 100;
                }
            });
        }
        return sum + width;
    }, 0);
    let upperWidth = Object.keys(upper).reduce((sum, key) => {
        let width = 54;
        if (Array.isArray(upper[key])) {
            upper[key].forEach((obj) => {
                if (obj.Width !== 1) {
                    width = 100;
                }
            });
        }
        return sum + width;
    }, 0);
    return { lower, upper, fares, newCountLower, newCountUpper, upperWidth, lowerWidth }


}

const parseSt = (val) => {
    let keys = Object.keys(val);
    for (let i = 0; i < keys.length; i++) {
        if (keys[i + 1] - keys[i] > 1) {
            val[parseInt(keys[i], 10) + 1] = false;
        }
        if (
            val[keys[i]] &&
            val[keys[i]].length === 0 &&
            val[keys[i + 1]] &&
            val[keys[i + 1]].length === 0
        ) {
            val[keys[i]] = false;
            delete val[keys[i + 1]];
        }
    }
    return val;
};


export const getWidthForDiv = (el) => {
    for (let i = 0; i < el.length; i++) {
        if (el[i].Width === 1) {
            return "31px";
        } else {
            return "70px";
        }
    }
    return "31px";
};


export const generateSeatStyle = (ell, index, bkgColor = {}, selectSeat = []) => {
    const defaultBg = !(['Q']?.includes(ell.newBkgType)) && selectSeat?.filter((obj) => obj?.SeatLabel === ell?.SeatLabel)?.length !== 0
        ? '#fac736'
        : bkgColor.hasOwnProperty(ell.newBkgType)
            ? `rgb(${bkgColor?.[ell.newBkgType]})`
            : ['sleeper', 'seat', "semisleeper"]?.includes(ell.SeatType)
                ? '#c6dac1'
                : '#fff';
    return {
        position: "absolute",
        top: `${ell.RowNo * 54}px`,
        left: `${index * 54}px`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: ell.Width === 1 ? 45 : 100 + "px",//Width
        height: ell.Height === 1 ? 45 : 100 + "px",
        fontSize:
            ell.DefaultCurrencyID !== 2
                ? ell.Width === 1
                    ? "10px"
                    : "10px"
                : "10px",
        paddingRight: "0",
        border: ell.Gender === "F" ? "2px solid" : "1px solid",
        borderColor: ell.IsAC === 1 ? 'red' : '#444',
        color: bkgColor.hasOwnProperty(ell.newBkgType) && ell?.newBkgType !== "P" ? '#fff' : '#5e5d5f',
        opacity: 1,
        userSelect: "none",
        fontWeight: 600,
        cursor: isNonBookableAmenitySeat(ell) ? "not-allowed" : "not-allowed",
        borderRadius: '4px',
        backgroundColor: resolveSeatBackgroundColor(ell, bkgColor, selectSeat, defaultBg),
    };
};


export const getHeightForDiv = (el) => {
    let tempHt = 0;
    for (let i = 0; i < el.length; i++) {
        tempHt += el[i].Height * 45;
    }
    return tempHt + "px";
};
export const logout = () => {
    sessionStorage.removeItem('BusCrsCheckSum')
    window.location.replace('/')
}

export const isEmpty = (obj) => {
    return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype
}



export const checkEmailValid = (val) => {
    if (val.length) {
        var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        return emailReg.test(val);
    }
    else
        return true;
}

export const checkPhoneValid = (val) => {
    if (val.length) {
        const phoneReg = /^[6-9]\d{9}$/;
        return phoneReg.test(val);
    } else {
        return false;
    }
};

export const checkGSTValid = (val) => {
    if (val.length) {
        const gstReg = new RegExp('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9A-Z]{1}$');
        return gstReg.test(val);
    }
    else
        return true;
}

export const groupByMultiKey = (array, keys) => {
    return array.reduce((result, item) => {
        let currentLevel = result;

        keys.forEach((key, index) => {
            const groupKey = item[key];
            if (!currentLevel[groupKey]) {
                currentLevel[groupKey] = index === keys.length - 1 ? [] : {};
            }
            currentLevel = currentLevel[groupKey];
        });

        currentLevel.push(item);
        return result;
    }, {});
};


export const generateMoveSeatStyle = (ell, index, selectSeat = []) => {
    const defaultBg = selectSeat?.filter((obj) => obj?.SeatLabel === ell?.SeatLabel)?.length !== 0
        ? '#fac736'
        : ell.IsAvailable === 1 && ['sleeper', 'seat', "semisleeper"]?.includes(ell.SeatType)
            ? '#c6dac1'
            : 'rgb(128, 128, 128)';
    return {
        position: "absolute",
        top: `${ell.RowNo * 54}px`,
        left: `${index * 54}px`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: ell.Width === 1 ? 45 : 100 + "px",//Width
        height: ell.Height === 1 ? 45 : 100 + "px",
        fontSize:
            ell.DefaultCurrencyID !== 2
                ? ell.Width === 1
                    ? "10px"
                    : "10px"
                : "10px",
        paddingRight: "0",
        border: ell.Gender === "F" ? "2px solid" : "1px solid",
        borderColor: ell.IsAC === 1 ? 'red' : '#444',
        color: ell.IsAvailable === 1 && ['sleeper', 'seat', "semisleeper"]?.includes(ell.SeatType) ? '#5e5d5f' : ['Q']?.includes(ell.BookingType) || (ell?.IsAvailable === 0 && ell?.BookingID?.trim() !== '') ? '#fff' : '#5e5d5f',
        opacity: 1,
        userSelect: "none",
        fontWeight: 600,
        cursor: "not-allowed",
        borderRadius: '4px',
        backgroundColor: resolveSeatBackgroundColor(ell, {}, selectSeat, defaultBg),
    };
};


export const generateSeatCancelStyle = (ell, index, bkgColor = {}, selectSeat = []) => {
    const defaultBg = ell.IsAvailable === 0 && (ell.BookingID?.trim() !== '' && ell.BookingID !== null)
        ? 'rgb(231, 29, 29)'
        : ['Q']?.includes(ell.newBkgType)
            ? bkgColor.hasOwnProperty(ell.newBkgType)
                ? `rgb(${bkgColor?.[ell.newBkgType]})`
                : '#d3d3d3'
            : '#d3d3d3';
    return {
        position: "absolute",
        top: `${ell.RowNo * 54}px`,
        left: `${index * 54}px`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: ell.Width === 1 ? 45 : 100 + "px",//Width
        height: ell.Height === 1 ? 45 : 100 + "px",
        fontSize:
            ell.DefaultCurrencyID !== 2
                ? ell.Width === 1
                    ? "10px"
                    : "10px"
                : "10px",
        paddingRight: "0",
        border: ell.Gender === "F" ? "2px solid" : "1px solid",
        borderColor: '#444',
        color: bkgColor.hasOwnProperty(ell.newBkgType) && ell?.newBkgType !== "P" ? '#fff' : '#5e5d5f',
        opacity: 1,
        userSelect: "none",
        fontWeight: 600,
        cursor: "not-allowed",
        borderRadius: '4px',
        backgroundColor: resolveSeatBackgroundColor(ell, bkgColor, selectSeat, defaultBg),
    };
};

export const mergedArrayObject = (data) => {
    const merged = data.reduce((result, item) => {
        Object.keys(item).forEach(key => {
            result[key] = result[key] ? result[key] + "," + item[key] : String(item[key]);
        });
        return result;
    }, {});

    return merged
}

export const mergedArraySeparateObject = (data) => {
    const merged = data.reduce((result, item) => {
        Object.keys(item).forEach(key => {
            result[key] = result[key] ? result[key] + "^" + item[key] : String(item[key]);
        });
        return result;
    }, {});

    return merged
}

export const removeDuplicatesFromArray = (array, property) => {
    const uniqueValues = new Set() // Set to store unique property values
    const uniqueArray = [] // Array to store unique objects
  
    array?.forEach((obj) => {
      const propertyValue = obj[property] // Get the property value of the current object
  
      if (!uniqueValues.has(propertyValue)) {
        // If property value is not already in the set
        uniqueValues.add(propertyValue) // Add it to the set
        uniqueArray.push(obj) // Add the object to the unique array
      }
    })
  
    return uniqueArray
  }
  export const generateChecksum =(requestBody, saltKey)=> {
    // Sort alphabetical keys of create order request body JSON and construct string
    const sortedKeys = Object.keys(requestBody).sort();
    const checksumString = sortedKeys
      .filter(key => key !== 'checksum'&& !(key === 'transferfee' && requestBody[key] === 0)) // Exclude 'checksum' key if present & transferFee if its value is 0
      .map(key => `${key}:${requestBody[key]}`) // Use backticks for template literals
      .join('|');
  
    // Append salt key
    const checksumStringWithSalt = `${checksumString}|${saltKey}`; // Use backticks for template literals
  
    // Use SHA256 encryption to generate checksum digest
    const checksumDigest = CryptoJS.SHA256(checksumStringWithSalt).toString();
    return checksumDigest;
  }